import React from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import panelStyles from "../styles/Panel.module.css";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageControls from "../shared/PageControls";
import PageContent from "../shared/PageContent";
import AnalyticsSection from "../sections/AnalyticsSection";

const ANALYTICS_TABS = [
  { id: "overview", label: "Обзор" },
  { id: "funnel", label: "Воронка" },
  { id: "retention", label: "Удержание" },
  { id: "revenue", label: "Выручка" },
  { id: "cohorts", label: "Когорты" },
  { id: "roles", label: "Роли" },
  { id: "requests", label: "Запросы" }
];

function normalizeTab(value) {
  return ANALYTICS_TABS.some((tab) => tab.id === value) ? value : "overview";
}

export function AnalyticsPage({ analytics, adminToken }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pathTab = location.pathname.endsWith("/requests") ? "requests" : null;
  const tab = normalizeTab(pathTab || searchParams.get("tab"));

  const setTab = (nextTab) => {
    if (nextTab === "requests") {
      navigate("/admin/analytics/requests", { replace: true });
      return;
    }

    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", nextTab);
    navigate(`/admin/analytics?${nextParams.toString()}`, { replace: true });
  };

  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Аналитика"
        description="Следите за активацией, выручкой, потерями в воронке, удержанием и когортами."
        actions={
          <button
            type="button"
            className={panelStyles.button}
            onClick={analytics.actions.refresh}
            disabled={!adminToken || analytics.loading}
          >
            {analytics.loading ? "Обновляем..." : "Обновить"}
          </button>
        }
      />

      <PageControls>
        <div className={pageStyles.tabList} role="tablist" aria-label="Разделы аналитики">
          {ANALYTICS_TABS.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={tab === item.id}
              className={tab === item.id ? pageStyles.tabActive : pageStyles.tab}
              onClick={() => setTab(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </PageControls>

      <PageContent>
        <AnalyticsSection
          mode="page"
          tab={tab}
          analyticsData={analytics.data.analytics}
          analyticsLoading={analytics.loading}
        />
      </PageContent>
    </div>
  );
}

export default AnalyticsPage;
